<!--
 * @Author: Axs <i@axs.email>
 * @Date: 2020-04-24 17:09:42
 * @LastEditors: Axs <i@axs.email>
 * @LastEditTime: 2021-05-07 16:49:54
 * @Description: 
 * @FilePath: /src/page/main.vue
--> 
<style lang="less" scoped>
    @import url('~@/lib/base.less');
    .main {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: #f6f6f6;
        .page {
            padding-bottom: @tabbarSecurityHeight + @tabbarHeight !important;
        }
    }
</style>

<template>
    <div class="main">
        <keep-alive>
            <router-view v-if="$route.meta.keepAlive" />
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive" />
        <tabbar :route.sync="route" />
    </div>
</template>

<script>
    import tabbar from '@/components/tabbar/index.vue';
    export default {
        data() {
            return {

            }
        },
        computed: {
            // 监听路由
            route() {
                return this.$route.path;
            }
        },
        components: {
            tabbar
        },
    }
</script>
